import Box from '@mui/material/Box';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import Typography from '@mui/material/Typography';
import {
    Checkbox,
    Table, TableBody,
    TableCell, TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import Paper from "@mui/material/Paper";
import {NoteHistory} from "../../../interface/noteHistory.interface";
import {styles} from 'common/style';
import {constance} from "../../../common/constance/constance";
import {common} from "../../../common/common";
import {User} from "../../../interface/user.interface";
import {isMobile} from "react-device-detect";

interface State {
    noteHistoryList: NoteHistory[],
    totalCount: number,
    page: number,
    deleteNoteIdList: string[]
}

export default function NoteListTable(props: { id: string, noteHistoryList: NoteHistory[], deleteNoteIdList: string[], checkDeleteNote: any, clickNote: any }) {
    console.log('NoteListTable');
    let fontSize: any = isMobile ? "subtitle2" : "subtitle1";

    return (
        <>
            <TableContainer component={Paper}>
                <Table sx={{minWidth: 300}} size={'medium'} aria-label="a dense table">
                    <TableHead>
                        <TableRow sx={{'th': {padding: '16px'}}}>
                            <TableCell align="center">
                                <Typography variant={fontSize}>선택</Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant={fontSize}>{props.id == constance.noteType.sentInbox ? '받는사람' : '보낸사람'}</Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography variant={fontSize}>내용</Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant={fontSize}>{props.id == constance.noteType.sentInbox ? '보낸날짜' : '받은사람'}</Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography variant={fontSize}>상태</Typography>
                            </TableCell>
                        </TableRow>

                    </TableHead>
                    <TableBody>
                        {
                            props.noteHistoryList.map((note, index) => {
                                /* 사진이 첨부 된 쪽지일 경우*/
                                let content = note.content;
                                if (note.content.indexOf('<img') > -1) {
                                    content = `<p style="color: ${styles.fontColor.comment}">[사진 첨부]</p>` + note.content
                                }

                                let user: User = {
                                    _id: "",
                                    admin: false,
                                    departmentCode: "",
                                    departmentName: "",
                                    id: "",
                                    name: ""
                                };
                                if (props.id == constance.noteType.sentInbox) {
                                    user = note.receiver;
                                } else {
                                    user = note.sender;
                                }

                                return <React.Fragment key={index}>
                                    <TableRow sx={{
                                        width: 1,
                                        '&:last-child td, &:last-child th': {border: 0},
                                        'td': {padding: '8px'},
                                        ':hover': {
                                            background: styles.tableHoverColor,
                                        },
                                        transition: styles.transition,
                                    }}
                                    >
                                        {/* 선택 */}
                                        <TableCell align="center"
                                                   variant={fontSize}
                                                   sx={{minWidth: {xs: 0.5, sm: 0.5, md: ''}}}>
                                            <Checkbox checked={props.deleteNoteIdList[index] == note._id}
                                                      onChange={event => props.checkDeleteNote(event, index, note)}/>
                                        </TableCell>

                                        {/* 받는사람 or 보낸사람 */}
                                        <TableCell align="center"
                                                   sx={{minWidth: {xs: 0.5, sm: 0.5, md: ''}}}>
                                            <Typography variant={fontSize} sx={{minWidth: 100}}>
                                                {`${user.departmentName} ${user.name}`}
                                            </Typography>
                                        </TableCell>

                                        {/* 내용 */}
                                        <TableCell align="left"
                                                   onClick={() => props.clickNote(note)}
                                                   variant={fontSize}
                                                   sx={{
                                                       width: 0.5, cursor: 'pointer',
                                                       minWidth: {xs: 200, sm: 200, md: ''}
                                                   }}>
                                            {
                                                note.type == constance.noteType.normal ?
                                                    <Typography variant={fontSize}
                                                                className={'textHidden'}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: `${content}`,
                                                                }}
                                                                sx={{
                                                                    cursor: 'pointer',
                                                                    flexGrow: 1,
                                                                    maxWidth: {xs: 1, sm: 1, md: 0.6},
                                                                    mb: 0.5, mt: 0.5, pl: 1,
                                                                    height: 20,
                                                                    overflow: 'hidden',
                                                                    '>p': {
                                                                        margin: 0,
                                                                        display: 'flex',
                                                                        flexWrap: 'wrap',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'pre-wrap',
                                                                    },
                                                                    'p>img': {
                                                                        maxWidth: 1,
                                                                    },
                                                                    // ...styles.textKeepAll
                                                                }}>
                                                    </Typography>
                                                    :
                                                    <Typography variant={fontSize}
                                                                sx={{
                                                                    color: styles.fontColor.comment,
                                                                    ml: 1,
                                                                    // display: {xs: 'none', sm: 'none', md: 'block'}
                                                                }}>
                                                        {`[감사카드] 를 ${props.id == constance.noteType.sentInbox? '보냈습니다.' : '받았습니다.'}`}
                                                    </Typography>
                                            }
                                        </TableCell>

                                        {/* 날짜 */}
                                        <TableCell align="center"
                                                   sx={{maxWidth: {xs: 0.25, sm: 0.25, md: ''}}}>
                                            <Typography variant={fontSize} sx={{minWidth: {xs: 100, sm: 100, md: ''}}}>
                                                {`${common.getTimeFormat(note.createdAt)}`}
                                            </Typography>
                                        </TableCell>

                                        {/* 상태 */}
                                        <TableCell align="center"
                                                   sx={{maxWidth: {xs: 0.25, sm: 0.25, md: ''}}}>
                                            <Typography variant={'subtitle2'} sx={{minWidth: {xs: 50, sm: 50, md: ''}}}>
                                                {note.receiverConfirmDate != null ? '읽음' : '안읽음'}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            })}

                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}
